module.exports = __webpack_public_path__ + "img/business_bg.1f7b003d.png";